import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

const { carbon, blue } = colorsPalettes;

export const Competitors = styled(FlexRow)`
    ${setFontVariant("body2", carbon[300])};
`;

export const NameContainer = styled(FlexColumn)`
    gap: 4px;
`;

export const NameRow = styled(FlexRow)`
    gap: 8px;
    align-items: center;

    .customIcon {
        width: auto;
        height: auto;
    }

    .hidden-icon {
        display: none;
        transition: 0.2s opacity ease-in-out;
    }
`;

export const CustomIcon = styled(SWReactIcons)`
    #inner,
    #outer {
        fill: ${blue[400]};
    }
`;

export const Separator = styled.span`
    margin: 0 8px;
`;

export const TooltipBody = styled.div`
    width: fit-content;
    white-space: pre-line;
`;
